"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toggleShowMoreAttribute = exports.toggleExpandAttribute = exports.toggleAttribute = exports.clearAttributes = exports.updateAttributes = exports.selectedAttributes = exports.getResultAttributes = void 0;
var getResultAttributes = function (attrs) {
    if (!attrs) {
        return null;
    }
    return attrs.map(function (attr) { return ({
        name: attr.Name,
        displayName: attr.DisplayName,
        sortOrder: attr.SortOrder,
        values: attr.Values.map(function (value) { return ({
            name: value.Name,
            displayName: value.DisplayName,
            checked: value.Checked,
            count: value.Count
        }); }),
        expanded: true,
        showMore: false
    }); });
};
exports.getResultAttributes = getResultAttributes;
var selectedAttributes = function (attributes) {
    if (attributes === null) {
        return [];
    }
    var selected = [];
    attributes.forEach(function (attribute) {
        attribute.values
            .filter(function (value) { return value.checked; })
            .forEach(function (value) { return selected
            .push({ name: attribute.name, value: value.name }); });
    });
    return selected;
};
exports.selectedAttributes = selectedAttributes;
var updateAttributes = function (updatedAttrs, currentAttrs) {
    return refreshAttributes(currentAttrs, exports.getResultAttributes(updatedAttrs));
};
exports.updateAttributes = updateAttributes;
var clearAttributes = function (attrs) {
    if (attrs === null) {
        return null;
    }
    return attrs.map(function (attr) { return (__assign(__assign({}, attr), { values: attr.values.map(function (value) {
            return (__assign(__assign({}, value), { checked: false }));
        }) })); });
};
exports.clearAttributes = clearAttributes;
var toggleAttribute = function (attrs, attribute, val) {
    if (attrs === null) {
        return null;
    }
    return attrs.map(function (attr) { return (__assign(__assign({}, attr), { values: attr.values.map(function (value) {
            return (__assign(__assign({}, value), { checked: attr.name === attribute && value.name === val ?
                    !value.checked : value.checked }));
        }) })); });
};
exports.toggleAttribute = toggleAttribute;
var toggleExpandAttribute = function (attrs, attribute) {
    if (attrs === null) {
        return null;
    }
    return attrs.map(function (attr) { return (__assign(__assign({}, attr), { expanded: attr.name === attribute ?
            !attr.expanded : attr.expanded })); });
};
exports.toggleExpandAttribute = toggleExpandAttribute;
var toggleShowMoreAttribute = function (attrs, attribute) {
    if (attrs === null) {
        return null;
    }
    return attrs.map(function (attr) { return (__assign(__assign({}, attr), { showMore: attr.name === attribute ?
            !attr.showMore : attr.showMore })); });
};
exports.toggleShowMoreAttribute = toggleShowMoreAttribute;
var refreshAttributes = function (current, updated) {
    if (!updated) {
        return null;
    }
    return updated.map(function (attr) {
        var oldAttr = current ? current.find(function (old) { return old.name === attr.name; }) : null;
        if (oldAttr) {
            return __assign(__assign({}, attr), { expanded: oldAttr.expanded, showMore: oldAttr.showMore });
        }
        return attr;
    });
};
